import { render, staticRenderFns } from "./jinfedetaile.vue?vue&type=template&id=f25a3f12&scoped=true&"
import script from "./jinfedetaile.vue?vue&type=script&lang=js&"
export * from "./jinfedetaile.vue?vue&type=script&lang=js&"
import style0 from "./jinfedetaile.vue?vue&type=style&index=0&id=f25a3f12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25a3f12",
  null
  
)

export default component.exports